import React, { useCallback } from 'react';
import { HeaderIcon, IconCart } from '@banhala/ui-kit';
import { useNavigator } from '../../utils';
import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { useOnForeground } from '../../hooks';
import { useLogAnalyticsEvent } from '../../hooks/useLogAnalyticsEvent';
import { queryKey } from '../../constant';
import { cartService } from '../../api';

interface CartIconProps {
  backgroundColor?: 'white' | 'transparent';
}

interface CartIconInternalProps {
  onPress: () => void;
  backgroundColor: 'white' | 'transparent';
}

export const CartIcon = ({ backgroundColor }: CartIconProps) => {
  const { navigator } = useNavigator();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handlePress = () => {
    logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_CART',
      analytics: { LANDING_FROM: 'CARTICON' },
    });
    navigator.moveToWebview('Cart');
  };

  return (
    <React.Suspense
      fallback={
        <HeaderIcon testID={'장바구니버튼'} onPress={handlePress}>
          <IconCart />
        </HeaderIcon>
      }
    >
      <CartIconInternal
        backgroundColor={backgroundColor ?? 'white'}
        onPress={handlePress}
      />
    </React.Suspense>
  );
};

const CartIconInternal = ({
  onPress,
  backgroundColor,
}: CartIconInternalProps) => {
  const queryClient = useQueryClient();

  useOnForeground(
    useCallback(() => {
      queryClient.invalidateQueries({ queryKey: queryKey.cartMeta });
    }, [queryClient]),
  );

  const { data: cartsCount } = useSuspenseQuery({
    queryKey: queryKey.cartMeta,
    queryFn: cartService.getCartMeta,
    select: data => data.carts_count,
    staleTime: 0,
  });

  return (
    <HeaderIcon
      onPress={onPress}
      badgeNum={cartsCount > 0 ? cartsCount : undefined}
      testID={'장바구니버튼'}
      backgroundColor={backgroundColor}
    >
      <IconCart />
    </HeaderIcon>
  );
};
